import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Action } from '../../../../../../components/index';
import { FileExportIcon } from '../../../../../../components/icon/solid';
import { setOpenModalExportMedia, setDataExportMedia } from '../../../../../../store/modules/articles/actions';
import { Article } from '../../../../../../types/items';
import { MediaStyles } from '../styles';

type Props = {
  media: Article;
};

const ExportMediaAction = ({ media }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(setDataExportMedia(media));
    dispatch(setOpenModalExportMedia(true));
  }, [dispatch, media]);

  return (
    <Action
      title="Downloads & Exports"
      icon={<FileExportIcon className={classes.actionIcon} />}
      onClick={onClick}
    />
  );
};

export default ExportMediaAction;
